/* global Fw, tinyMCE */

(function ($, d, g) {
    /* jshint validthis: true */
    "use strict";
    var formValidator;
    var tools;
    var step1;
    var eventSessionSelector;
    var eventPastSessionSelector;
    var number;
    var fname;
    var lname;
    var email;
    var sendEmail;
    var participantsInfos;
    var participantNotFoundCheck;
    var fetchPastEventsBtn;
    var fetchFuturEventsBtn;

    var step2;
    var step3;
    var step4;

    var submitStep;
    var submitLastStep;
    var backStep;
    var cashToggleBtn;
    var triggeredBtn;
    
    window.eventsData = [];

    function saveEventInSession() {
        var t = $(this);
        var val = t.val();
        var ctn = t.closest(".registration-event-selector");
        var key1 = ctn.find(fetchFuturEventsBtn).attr("data-key");
        var key2 = ctn.find(fetchPastEventsBtn).attr("data-key");

        if (key1 && key1 !== "") {
            ajax("/action/sessionVariables?key=" + key1 + "&value=" + val, null, true);
        }
        if (key2 && key2 !== "") {
            ajax("/action/sessionVariables?key=" + key2 + 
                (t.hasClass("registration-event-select-past") ? "&value=true" : "&value="), null, true);
        }

        // Integrate the logic from the separate listener here:
        var selectedEventId = val; // Since val is the value of the selected option
        var selectedEvent = window.eventsData.find(event => event.id == selectedEventId);
        // Clear the dynamicFieldsContainer
        $("#dynamicFieldsContainer").empty();

        // Check if the selected event has the required fields
        if (selectedEvent) {
            for (var i = 1; i <= 6; i++) {
                var fieldKey = "field" + i;
                if (selectedEvent[fieldKey]) {
                    createDynamicFields(selectedEvent[fieldKey], i, selectedEventId);
                }
            }
        }
    }

    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
    function checkMember() {
        var t = $(this);
        var val = t.val();

        var registrationType = $(".registration-account-type", step1);
        var participantNotFound = $(".registration-participant-not-found", step1);
        var url = "/action/pmiAccount";
        url += "?pmiNumberRegistration=" + val;

        ajax(url, function (response) {
            try {
                var json = JSON.parse(response.trim());

                if (json.firstName) {
                    fname.val(decodeHtml(json.firstName));
                }
                fname.removeClass("error").removeClass("disabled");
                if (json.lastName) {
                    lname.val(decodeHtml(json.lastName));
                }
                lname.removeClass("error").removeClass("disabled");
                if (json.email) {
                    email.val(decodeHtml(json.email));
                }
                email.removeClass("error");

                registrationType.addClass("hide");
                participantNotFound.addClass("hide");
                participantNotFound.find("input").attr("checked", false);

                if (json.expired === 'true') {
                    registrationType.filter(".expired").removeClass("hide");
                } else if (json.member === 'true') {
                    registrationType.filter(".member").removeClass("hide");
                } else if (json.student === 'true') {
                    registrationType.filter(".student").removeClass("hide");
                } else if (json.member === 'false') {
                    registrationType.filter(".non-member").removeClass("hide");
                } else {
                    registrationType.filter(".guest").removeClass("hide");
                    registrationType.filter(".non-valid").removeClass("hide");
                    participantNotFound.removeClass("hide");
                }

            } catch (e) {
                registrationType.addClass("hide");
                registrationType.filter(".guest").removeClass("hide");
                if (val !== '') {
                    registrationType.filter(".non-valid").removeClass("hide");
                }
                participantNotFound.removeClass("hide");
                fname.val("");
                lname.val("");
                email.val("");
            }
        }, true);
    }
    function checkMemberType(memberId) {
        var registrationType = $(".registration-account-type", step1);
        var participantNotFound = $(".registration-participant-not-found", step1);


        var url = "/action/pmiAccount";
        url += "?pmiNumberRegistration=" + memberId;
        ajax(url, function (response) {
            try {
                registrationType.addClass("hide");
                participantNotFound.addClass("hide");
                participantNotFound.find("input").attr("checked", false);
                var json = JSON.parse(response.trim());
                if (json.expired === 'true') {
                    registrationType.filter(".expired").removeClass("hide");
                } else if (json.member === 'true') {
                    registrationType.filter(".member").removeClass("hide");
                } else if (json.student === 'true') {
                    registrationType.filter(".student").removeClass("hide");
                } else if (json.member === 'false') {
                    registrationType.filter(".non-member").removeClass("hide");
                } else {
                    registrationType.filter(".guest").removeClass("hide");
                    registrationType.filter(".non-valid").removeClass("hide");
                    participantNotFound.removeClass("hide");
                }

            } catch (e) {
                registrationType.addClass("hide");
                registrationType.filter(".guest").removeClass("hide");
                if (memberId !== '') {
                    registrationType.filter(".non-valid").removeClass("hide");
                }
                participantNotFound.removeClass("hide");
                fname.val("");
                lname.val("");
                email.val("");
            }
        }, true);
    }

    function toggleEmail() {
        var t = $(this);
        var checked = t.is(":checked");

        var emailField = $(".registration-send-email-field", step1);

        if (checked) {
            emailField.removeClass("hide");
            emailField.find("input").addClass("required");
        } else {
            emailField.addClass("hide");
            emailField.find("input").removeClass("required");
        }
    }

    function toggleEmailCreateAccount() {
        var t = $(this);
        var checked = t.is(":checked");

        var emailField = $(".registration-create-account-field", step1);
        if (checked) {
            emailField.removeClass("hide");
            emailField.find("input").addClass("required");
        } else {
            emailField.addClass("hide");
            emailField.find("input").removeClass("required");
        }
    }

    function submitForm() {
        var btn = $(this);
        var form = btn.closest('form');

        if (form.find('.esmp-input').length > 0) {
            compileMetaDataForStep1(form);
        }
        btn.addClass("disabled");
        formValidator.validateForm(form);
        if (!form.hasClass('has-error')) {
            form.submit();
        } else {
            btn.removeClass("disabled");
        }
    }

    function backForm(e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = $(this);
        btn.addClass("disabled");
        var form = $(".back-step-form");
        form.submit();
    }

    function fetchPastEvents(e, th) {
        var t = (th !== undefined) ? th : $(this);
        var futur = t.attr("data-futur") === 'true';
        var eId = t.attr("data-extra");

        if (!futur) {
            eventSessionSelector.parent().addClass("hide");
            eventSessionSelector.attr("name", "eventId-temp");
            eventPastSessionSelector.parent().removeClass("hide");
            eventPastSessionSelector.attr("name", "eventId");
            if (eventSessionSelector.hasClass("required")) {
                eventSessionSelector.removeClass("required");
                eventPastSessionSelector.addClass("required");
            }
            fetchPastEventsBtn.addClass("hide");
            fetchFuturEventsBtn.removeClass("hide");
            
            if (!eventPastSessionSelector.hasClass("unloaded")) {
                ajax("/action/pmiAjaxGetEvent?past=true", function (response) {
                    try {
                        var json = JSON.parse(response.trim());
                        window.eventsData = json;
                        for (var j in json) {
                            var event = json[j];
                            var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                            if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                                option.attr("selected", "true");
                            }
                            eventPastSessionSelector.append(option);
                        }
                        eventPastSessionSelector.addClass("unloaded");
                    } catch (e) {
                        console.error(e);
                    }
                }, true);
            }
        } else {
            eventSessionSelector.parent().removeClass("hide");
            eventSessionSelector.attr("name", "eventId");
            eventPastSessionSelector.parent().addClass("hide");
            eventPastSessionSelector.attr("name", "eventId-temp");
            if (eventPastSessionSelector.hasClass("required")) {
                eventSessionSelector.addClass("required");
                eventPastSessionSelector.removeClass("required");
            }
            fetchPastEventsBtn.removeClass("hide");
            fetchFuturEventsBtn.addClass("hide");
            ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    window.eventsData = json;
                    for (var j in json) {
                        var event = json[j];
                        var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                        if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                            option.attr("selected", "true");
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }, true);
        }
    }

    function toggleCash() {
        var t = $(this);
        var ctn = t.closest('.toggle-outer-ctn');
        var el = ctn.find('.element-to-toggle'); //Card fields

        el.slideUp();
        el.find('.required').removeClass('required').addClass('derequired');
    }

    function visibleToggle() {
        var t = $(this);
        var ctn = t.closest('.toggle-outer-ctn');
        var el = ctn.find('.element-to-toggle');

        el.addClass("hide");
        var index = ctn.find(".toggle-trigger-element").index(this);
        $(el.get(index)).slideDown();

        setTimeout(function () {
            el.css("visibility", "visible");
        }, 1000);
    }

    function createDynamicFields(data, key, eventId) {
        var values = data.split("_!_")[0];
        var required = data.split("_!_")[1] === "true";
        var type = data.split("_!_")[2];

        var container = $("#dynamicFieldsContainer");

        var lblCls = "esmap-label" + key;
        var labelSuffix = "register-event-metadata" + key + "." + eventId;
        var labelKey = "page.form.input." + labelSuffix;

        // Fetch the label using AJAX
        ajax('/action/getLabel?key=' + labelKey + "&site", function (response) {
            
            var labelText = response.trim();
            var visibleLabelElem = $("<label>", {
                for: "metaData_part" + key,
                text: (!labelText)? labelText: "",
                class: "form-input-label"
            });

            // Now, continue with the rest of the input creation logic
            switch (type) {
                case "text":
                    var inputElem = $("<input>", {
                        type: "text",
                        name: "metaData_part" + key,
                        class: "form-input esmp-input",
                        placeholder: (!labelText)? labelText: ""
                    });
                    if (required) {
                        inputElem.attr("required", true);
                    }
                    inputElem.attr("data-extra", "." + lblCls);
                    container.append(inputElem);
                    break;

                case "checkbox":
                case "radio":
                    var choices = values.split(";");
                    var divElem = $("<div>", {
                        class: "input-ctn full event-signup-metadata-part"
                    });
                    choices.forEach(function (choice) {
                        var inputElem = $("<input>", {
                            type: type,
                            name: "metaData_part" + key,
                            value: choice,
                            class: "esmp-input"
                        });
                        if (required) {
                            inputElem.addClass("min-one-checked");
                        }
                        var labelElem = $("<label>").text(choice).prepend(inputElem);
                        divElem.append(labelElem);
                    });
                    container.append(divElem);
                    break;

                case "select":
                    var selectElem = $("<select>", {
                        name: "metaData_part" + key,
                        class: "form-select form-input esmp-input"
                    });
                    var placeholderOption = $("<option>", {
                        value: "",
                        text: (!labelText)? labelText: "",
                        disabled: true,
                        selected: true
                    });
                    selectElem.append(placeholderOption);
                    var defaultOption = $("<option>", {
                        value: "",
                        text: ""
                    });
                    selectElem.append(defaultOption);

                    var choices = values.split(";");
                    choices.forEach(function (choice) {
                        var optionElem = $("<option>", {
                            value: choice
                        }).text(choice);
                        selectElem.append(optionElem);
                    });
                    if (required) {
                        selectElem.attr("required", true);
                    }
                    selectElem.attr("data-extra", "." + lblCls);
                    container.append(selectElem);
                    break;

                default:
                    console.error("Unsupported type: " + type);

            }
            container.append(visibleLabelElem);
        });
    }

    function compileMetaDataForStep1($form) {
        var $parts = $form.find('.admin-registration-metadata-par');
        if ($parts.length) {
            var v = '';

            $parts.each(function (i, el) {
                var input = $(el).find('.esmp-input')[0];
                var labelEl = $form.find(input.getAttribute('data-extra'))[0];
                var line = '';

                if (input && input.value.trim() !== '') {
                    // Append the meta label
                    if (labelEl && labelEl.value.trim() !== '') {
                        line += labelEl.value.trim();
                        if (!line.match(': ')) {
                            line += ' = ';
                        }
                    }
                    // Append the meta value
                    line += input.value.trim();
                }
                // Append the meta line to the main value
                if (line !== '') {
                    v += (v !== '' ? '; \n' : '') + line;
                }
            });
            if ($('input[name="metaData"]').length != 0) {
                $('input[name="metaData"]').val(v);
            }
            else {
                $form.append('<input type="hidden" name="metaData" value="' + v.replace(/"/g, "&quot;") + '"/>');
            }
        }
    }

    function init(e) {
        ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
            try {
                var json = JSON.parse(response.trim());
                window.eventsData = json;
            } catch (e) {
                console.error(e);
            }
        }, true);
        if ($(".registration-event-selector").length) {
            // Only 1 instance per document is allowed
            // These elements are also used in page/manage-newsletter.js
            fetchPastEventsBtn = $(".registration-event-selector .select-past-event");
            fetchFuturEventsBtn = $(".registration-event-selector .select-futur-event");
            eventSessionSelector = $(".registration-event-select");
            eventPastSessionSelector = $(".registration-event-select-past");
            if (eventPastSessionSelector !== undefined && eventPastSessionSelector.attr("data-extra") !== undefined && eventPastSessionSelector.attr("data-extra") !== '') {
                fetchPastEvents(e, eventPastSessionSelector);
            }
            eventSessionSelector.on("change", saveEventInSession);
            fetchPastEventsBtn.on("click", fetchPastEvents);
            fetchFuturEventsBtn.on("click", fetchPastEvents);
        }
        
        //INIT STOP
        if (!d.querySelector(".admin-page.registration-zone")) return;

        formValidator = Fw.component.models().form;
        tools = Fw.component.models().tools;
        step1 = $(".registration-step1");
        number = $(".registration-number", step1);
        fname = $(".registration-fname", step1);
        lname = $(".registration-lname", step1);
        email = $(".registration-email", step1);
        sendEmail = $(".registration-send-email", step1);
        participantNotFoundCheck = $(".registration-create-account", step1);
        participantsInfos = $(".participant-infos", step1);

        step2 = $(".registration-step2");
        step3 = $(".registration-step3");
        step4 = $(".registration-step4");

        submitStep = $(".registration-submit-step");
        submitLastStep = $(".registration-submit-last-step");
        backStep = $(".registration-back-step");

        number.on("change", checkMember);
        sendEmail.on("click", toggleEmail);
        participantNotFoundCheck.on("click", toggleEmailCreateAccount);

        submitStep.on("click", submitForm);
        backStep.on("click", backForm);

        if (participantsInfos !== undefined && participantsInfos.attr("data-memberId") !== undefined && participantsInfos.attr("data-memberId") !== '') {
            checkMemberType(participantsInfos.attr("data-memberId"));
        }

        cashToggleBtn = $(".toggle-trigger-element-cash");
        cashToggleBtn.on("click", toggleCash);
        triggeredBtn = $(".toggle-trigger-element", step3);
        triggeredBtn.on("click", visibleToggle);
    }

    $(g).ready(init);

})(jQuery, document, window);
